import { hideNotification } from '@cian/favorites-assign-widget/es/shared/actions';

import { TThunkAction } from '../../types/redux';
import { TRecommendation } from '../../types/recommendation';
import { deleteFromFavorite as deleteFromFavoriteService } from '../../services/favorites';
import { toggleFavorite } from '../../actions/recommendations';

export function deleteFromFavorite(recommendation: TRecommendation): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    dispatch(hideNotification());
    dispatch(toggleFavorite({ offerId: recommendation.offerId, isFavorite: false }));

    try {
      await deleteFromFavoriteService(context, {
        dealType: recommendation.dealType,
        offerId: recommendation.offerId,
        offerType: recommendation.offerType,
      });
    } catch (error) {
      dispatch(toggleFavorite({ offerId: recommendation.offerId, isFavorite: true }));

      throw error;
    }
  };
}
